import React, { useMemo } from "react";
import { type Prize } from "kadow-jetpack-model";
import KC_Heading2 from "../../../../../designsystem/typography/KC-Heading/KC_Heading2";
import KC_Text from "../../../../../designsystem/typography/KC_Text/KC_Text";
import {
  KC_Text_Sizes,
  KC_Weights
} from "../../../../../designsystem/ds_commons";
import KC_Button, {
  KC_ButtonSize
} from "../../../../../designsystem/KC_Button/KC_Button";
import Carousel from "../../../../../components/Carousel/Carousel";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { tt } from "../../../../../utils/i18n/i18n";
import PrizesConfiguratorDisplayCard from "../component/PrizesConfiguratorDisplayCard";
import type { Config } from "kadow-jetpack-model";

const SECTION_DESCRIPTION_CLASS = "text-secondary";

interface PrizesSectionProps {
  config: Config;
  onChoosePrizesClick: () => void;
}

const PrizesSection: React.FC<PrizesSectionProps> = ({
  config,
  onChoosePrizesClick
}) => {
  const gamePrizesSlides = useMemo(
    () =>
      (config.prizes ?? []).map((prize: Prize) => (
        <div key={prize.name} className="prize-preview-container">
          <PrizesConfiguratorDisplayCard
            title={prize.name ?? tt("prizes_configurator_no_name_gift")}
            secondaryText={`${prize.pc?.toString() || "0"}%${prize.iQty ? tt("prizes_configurator_max_per_week", { quantity: prize.iQty }) : ""}`}
            img={prize.image}
          />
        </div>
      )),
    [config.prizes]
  );

  const choosePrizesButtonProps = {
    size: KC_ButtonSize.Large,
    text: tt("prizes_configurator_choose_my_prizes"),
    isPrimary: true,
    showIconOnTheRight: true,
    icon: faArrowRight,
    onClick: onChoosePrizesClick,
    extraStyle: { width: "unset !important" as const }
  };

  return (
    <section className="prizes-config-section">
      <div className="prizes-config-section__header">
        <div className="prizes-config-section__title-block">
          <div className="prizes-config-section__title-row">
            <KC_Heading2 text={tt("prizes_configurator_my_prizes")} />
          </div>
          <KC_Text
            size={KC_Text_Sizes.lg}
            weight={KC_Weights.reg}
            text={tt("prizes_configurator_text_about_prizes")}
            className={SECTION_DESCRIPTION_CLASS}
          />
        </div>
        <div className="prizes-config-section__actions">
          <KC_Button id="choose-game-prizes" {...choosePrizesButtonProps} />
        </div>
      </div>
      {!!(config.prizes?.length ?? 0) && (
        <div className="prizes-config-section__content">
          <Carousel
            slides={gamePrizesSlides}
            className="prize-slides flex-grow-1"
            baseId="ps"
            enableNavigationAllBreakpoints
          />
        </div>
      )}
    </section>
  );
};

export default PrizesSection;
